export default function listenForRhinoAuthEvents($log, rnAUTH_EVENTS, $gzSignin, $analytics, $rootScope) {
  'ngInject';

  $rootScope.$on(rnAUTH_EVENTS.signinSuccess, listenMsg);
  $rootScope.$on(rnAUTH_EVENTS.signinFailure, listenMsg);
  $rootScope.$on(rnAUTH_EVENTS.signinCanceled, listenMsg);
  $rootScope.$on(rnAUTH_EVENTS.signoutSuccess, listenMsg);
  $rootScope.$on(rnAUTH_EVENTS.sessionTimeout, signin);
  $rootScope.$on(rnAUTH_EVENTS.authenticated, updateAnalyticsUser);
  $rootScope.$on(rnAUTH_EVENTS.notAuthenticated, signin);
  // $rootScope.$on(rnAUTH_EVENTS.notAuthorized, listenMsg);


  function listenMsg(event, args) {
    $log.debug('gz-signin listener event: ' + event.name + '  -> ', args);
  }

  function signin(event, opts) {
    listenMsg(event, opts);

    if(!opts) {
      opts = {};
    }

    if(opts.reloadOnSignin === undefined) {
      opts.reloadOnSignin = true;
    }

    if(opts.blackoutOnSignin === undefined) {
      opts.blackoutOnSignin = true;
    }

    $gzSignin.signin(true);
  }

  function updateAnalyticsUser(event, args) {
    listenMsg(event, args);
    $analytics.setUsername(args.entity.id);
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/signin/signin.run.js